import {
  FlexColumn,
  FormControls,
  FormField,
  TextField,
} from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import { UseFormReturn } from 'react-hook-form';
import { AddTestForm } from 'shared/types';

type Props = {
  methods: UseFormReturn<AddTestForm, any, undefined>;
  defaultValue?: string;
  showCustomTestName?: boolean;
};

const TableTestDescriptionField = ({
  methods,
  defaultValue,
  showCustomTestName,
}: Props) => {
  const { register, watch } = methods;

  return (
    <FormControls.FieldsWrapper>
      <FlexColumn sx={{ gap: 1 }}>
        <FormField title="Description" optional>
          <FlexColumn sx={{ gap: 1 }}>
            <TextField
              autoComplete="off"
              defaultValue={defaultValue}
              multiline
              rows={3}
              maxRows={6}
              {...register('description')}
            />
            <Typography
              sx={{
                fontSize: '12px',
                color: 'common.gray11',
                visibility: watch('description') ? 'visible' : 'hidden',
              }}
            >
              {`${watch('description')?.length} Characters`}
            </Typography>
          </FlexColumn>
        </FormField>

        {showCustomTestName && (
          <FormField title="Custom test name" optional>
            <TextField
              autoComplete="off"
              size="large"
              placeholder="Override the default test name"
              {...register('testNameOverride')}
            />
          </FormField>
        )}
      </FlexColumn>
    </FormControls.FieldsWrapper>
  );
};

export default TableTestDescriptionField;
